<div class="top-bar"></div>
<div>
  <mat-card class="top-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Item Prices:</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div *ngIf="restaurant">
        <mat-toolbar>
          <span>Restaurant: </span>
          <span>{{ restaurant.name }}</span>
          <span class="example-spacer"></span>

          <mat-form-field style="margin-top: 15px">
            <mat-label>Filter</mat-label>
            <input
              matInput
              #filterInput
              (keyup)="applyFilter(filterInput.value)"
              placeholder="Item name.."
            />
            <button mat-icon-button matSuffix>
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>

          <button
            mat-icon-button
            class="example-icon"
            aria-label="Example icon-button with export icon"
            (click)="exportToExcel()"
          >
            <mat-icon>file_download</mat-icon>
          </button>
          <button
            mat-icon-button
            class="example-icon"
            aria-label="Example icon-button with refresh icon"
            (click)="loadItems()"
          >
            <mat-icon>refresh</mat-icon>
          </button>
        </mat-toolbar>
        <mat-progress-bar
          mode="query"
          *ngIf="loading === true"
        ></mat-progress-bar>

        <div class="mat-elevation-z8">
          <table mat-table matSort [dataSource]="dataSource">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell *matCellDef="let element">
                {{ element.name }}
              </td>
            </ng-container>
            <ng-container matColumnDef="kitchenName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Kitchen Name
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.kitchenName }}
              </td>
            </ng-container>
            <ng-container matColumnDef="plu">
              <th mat-header-cell *matHeaderCellDef>PLU</th>
              <td mat-cell *matCellDef="let element">
                {{ element.plu }}
              </td>
            </ng-container>

            <ng-container matColumnDef="price">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
              <td mat-cell *matCellDef="let element">
                {{ element.price | currency }}
              </td>
            </ng-container>

            <ng-container matColumnDef="active">
              <th mat-header-cell *matHeaderCellDef>Active</th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.active" color="primary"
                  >check_circle</mat-icon
                >
                <mat-icon *ngIf="!element.active" color="warn">cancel</mat-icon>
              </td>
            </ng-container>

            <ng-container matColumnDef="isCombo">
              <th mat-header-cell *matHeaderCellDef>Is Combo</th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.isCombo" color="primary"
                  >check_circle</mat-icon
                >
                <mat-icon *ngIf="!element.isCombo" color="warn"
                  >cancel</mat-icon
                >
              </td>
            </ng-container>

            <ng-container matColumnDef="availableSunday">
              <th mat-header-cell *matHeaderCellDef>Available Sunday</th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.availableSunday" color="primary"
                  >check_circle</mat-icon
                >
                <mat-icon *ngIf="!element.availableSunday" color="warn"
                  >cancel</mat-icon
                >
              </td>
            </ng-container>

            <ng-container matColumnDef="availableMonday">
              <th mat-header-cell *matHeaderCellDef>Available Monday</th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.availableMonday" color="primary"
                  >check_circle</mat-icon
                >
                <mat-icon *ngIf="!element.availableMonday" color="warn"
                  >cancel</mat-icon
                >
              </td>
            </ng-container>

            <ng-container matColumnDef="availableTuesday">
              <th mat-header-cell *matHeaderCellDef>Available Tuesday</th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.availableTuesday" color="primary"
                  >check_circle</mat-icon
                >
                <mat-icon *ngIf="!element.availableTuesday" color="warn"
                  >cancel</mat-icon
                >
              </td>
            </ng-container>

            <ng-container matColumnDef="availableWednesday">
              <th mat-header-cell *matHeaderCellDef>Available Wednesday</th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.availableWednesday" color="primary"
                  >check_circle</mat-icon
                >
                <mat-icon *ngIf="!element.availableWednesday" color="warn"
                  >cancel</mat-icon
                >
              </td>
            </ng-container>

            <ng-container matColumnDef="availableThursday">
              <th mat-header-cell *matHeaderCellDef>Available Thursday</th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.availableThursday" color="primary"
                  >check_circle</mat-icon
                >
                <mat-icon *ngIf="!element.availableThursday" color="warn"
                  >cancel</mat-icon
                >
              </td>
            </ng-container>

            <ng-container matColumnDef="availableFriday">
              <th mat-header-cell *matHeaderCellDef>Available Friday</th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.availableFriday" color="primary"
                  >check_circle</mat-icon
                >
                <mat-icon *ngIf="!element.availableFriday" color="warn"
                  >cancel</mat-icon
                >
              </td>
            </ng-container>

            <ng-container matColumnDef="availableSaturday">
              <th mat-header-cell *matHeaderCellDef>Available Saturday</th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.availableSaturday" color="primary"
                  >check_circle</mat-icon
                >
                <mat-icon *ngIf="!element.availableSaturday" color="warn"
                  >cancel</mat-icon
                >
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>

          <mat-paginator
            [pageSizeOptions]="[5, 10, 20]"
            showFirstLastButtons
            aria-label="Select page of item prices"
          >
          </mat-paginator>
        </div>
      </div>
      <div *ngIf="!restaurant">Please select a restaurant to view prices.</div>
    </mat-card-content>
  </mat-card>

  <span class="example-spacer"></span>

  <mat-card class="footer-card" appearance="outlined">
    <mat-card-content *ngIf="items && items.length > 0">
      <div style="text-align: right">
        <span matInput style="font-style: italic; font-size: 0.8em">
          Elapsed Time: {{ elapsedSeconds }}
        </span>
      </div>
    </mat-card-content>
  </mat-card>
</div>
